import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const list = async (params: object) => {
  return await GET({ url: Api.list, params, showError: false })
}
export const cancelChangeCity = async (params: object) => {
  return await POST({ url: Api.cancelChangeCity, params, showError: false })
}
export const courierAge = async (params: any) => {
  return await GET({
    url: Api.courierAge,
    params,
    showError: false
  })
}
export const detail = async (params: object) => {
  return await GET({ url: Api.detail, params, showError: false, isShowStatusError: false })
}
